<template>
  <cdn-svg
    v-tooltip="'Upgrade for advanced features'"
    path="nucleo/medal"
    :class="`${classesByPositioning[props.positioning]} c-p`"
  />
</template>

<script setup>
  const props = defineProps({
    positioning: { type: String, default: null },
  });

  const classesByPositioning = {
    absolute: 'pos-abs top-10 right-8', // For most input fields, absolutely positioned on the right side of the input
    selector: 'm-l4', // For selectors, inline positioned to the right of the dropdown icon
  };
</script>
